import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

function Notification() {
  const [page, setPage] = useState(1);
  const [notification, setNotification] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getLeadsData();
  }, [rowsPerPage, page]);

  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;
    setLoading(true);

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/get-notifications??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('notification', response)
      if (response.data.status === "RC200") {
        setNotification(response.data.data.data);
        setTotalRows(response.data.recordsTotal || 0);
      } else {
        setNotification([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setNotification([]);
    }
    setLoading(false);
  };

  // Custom row design inside DataTable
  const columns = [
    {
      name: "All Notifications",
      cell: (row) => (
        <div className="p-2">
          <p style={{ fontWeight: "700", color: "#475569CC", fontSize: "15px" }}>
            {row.title}
          </p>
          <p style={{ color: "#475569" }}>{row.message}</p>
          <p style={{ fontSize: "12px", color: "#64748B" }}>{row.date_time}</p>

        </div>
      ),
      sortable: false,
      grow: 1, 
    },
  ];

  return (
    <div className="p-3">
      {/* Breadcrumb */}
      <div className="d-flex align-items-center gap-3">
        <svg
          className="custom-icon"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"
          ></path>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="m8.25 4.5l7.5 7.5l-7.5 7.5"
          ></path>
        </svg>

        <p className="m-0">Notification</p>
      </div>

      {/* Notifications Section */}
      <div className="managebrand_box mt-3">
        {/* DataTable without Toggle */}
        <DataTable
          columns={columns}
          data={notification}
          progressPending={loading}
          pagination
          //paginationServer
          paginationRowsPerPageOptions={[50,100, 200, 300, 400]}
          //paginationTotalRows={totalRows}
          paginationPerPage={rowsPerPage}
          onChangePage={(page) => setPage(page)}
          onChangeRowsPerPage={(currentRowsPerPage) => {
            setRowsPerPage(currentRowsPerPage);
            setPage(1);
          }}
    noDataComponent={
            <div
              style={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                flexDirection: "column",
              }}
            >
              <h1 style={{ fontSize: "30px", fontWeight: "600" }}>
                No Notifications Found
              </h1>
              <p className="fs-5">
                The page you are looking for might not have any notifications
                yet.
              </p>
            </div>
          }

          customStyles={{
            headCells: {
              style: {
                fontSize: "20px",
                fontWeight: "500",
                color: "rgba(15, 23, 42, 1)",
                padding: "15px",
                textAlign: "left",
              },
            },
            rows: {
              style: {
                display: "block",
                padding: "5px",
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default Notification;
